<!--<section class="admin-authorization-container" [ngClass]="{'admin-auth-error': !this._valid}">-->
<section class="admin-authorization-container">

  <!--<ng-container *ngIf="loading;else show_table">-->
      <!--<gen-overlay-loader-->
              <!--[showOverlay]="false"-->
              <!--loaderType="SKELETON-TABLE"-->
      <!--&gt;</gen-overlay-loader>-->
  <!--</ng-container>-->

  <!--<ng-template #show_table>-->
    <gen-dynamic-form-table
            [emptyMessageDisplay]="config.emptyMessage"
            [showAddButton]="config.addButton"
            [showDeleteButton]="config.deleteButton"
            [data]="data"
            [itemNgClassRef]="checkIfGreyOut"
            [formId]="config.formId"
            [isItemEditModeRef]="getEditMode"
            [editMode]="!_widgetDisabledStatus"
            [isItemDisabledRef]="isItemDisable"
            [popupMode]="true"
            [listenToDataChange]="config.listenToDataChange"
            (itemUpdateEmitter)="onDataUpdate($event)"
    ></gen-dynamic-form-table>
  <!--</ng-template>-->
</section>
